// extracted by mini-css-extract-plugin
module.exports = {"container":"Previewer_container__3h2R5","dark":"Previewer_dark__2lcnX","navbar":"Previewer_navbar__3uQYg","main":"Previewer_main__2FPTx","nav-icon":"Previewer_nav-icon__1L1t5"};